import { Award } from "../../types";
import { VinoDataSKU, VinoDataWine } from "../../types/vino-data-types";
import { generateStorefrontImage } from "../../utils/generate-storefront-image";

export const awardsFromVinoDataWineSKU = (
  sku: VinoDataSKU,
  size: number
): Array<Award> => {
  if (!sku?.wines) return [];

  const summary = sku?.wines?.reduce((acc, wine) => {
    awardsFromVinoDataWine(wine, size).map((award: Award) => {
      acc[award.label]
        ? (acc[award.label].count += 1)
        : (acc[award.label] = award);
    });

    return acc;
  }, {});

  return Object.values(summary);
};

export const awardsFromVinoDataWine = (
  wine: VinoDataWine,
  size: number
): Array<Award> => {
  const { ratingsAndAwards } = wine;
  const imageWidth = size;

  if (!ratingsAndAwards) {
    return [];
  }

  const summary = ratingsAndAwards.reduce(
    (acc: { [key: string]: Award & { count: number } }, award) => {
      if (acc[award.name]) {
        acc[award.name].count += 1;
      } else {
        acc[award.name] = {
          label: award.name,
          image: generateStorefrontImage(award.image, { width: imageWidth }),
          count: 1,
        };
      }
      return acc;
    },
    {}
  );

  return Object.values(summary);
};
